import { render, staticRenderFns } from "./ScoreSelector.vue?vue&type=template&id=edfa4896&scoped=true&"
import script from "./ScoreSelector.vue?vue&type=script&lang=ts&"
export * from "./ScoreSelector.vue?vue&type=script&lang=ts&"
import style0 from "./ScoreSelector.vue?vue&type=style&index=0&id=edfa4896&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edfa4896",
  null
  
)

export default component.exports